import {
  BarChart3,
  Bike,
  Boxes,
  ClipboardList,
  CreditCard,
  FileUp,
  FileSpreadsheet,
  History,
  HandCoins,
  LifeBuoy,
  LayoutDashboard,
  PackageSearch,
  ReceiptText,
  ShieldCheck,
  Settings,
  ShoppingCart,
  Truck,
  UtensilsCrossed,
  UserRoundCog,
  WalletCards,
  type LucideIcon,
} from 'lucide-react';

export interface NavigationItem {
  label: string;
  href: string;
  icon: LucideIcon;
  description: string;
  ownerOnly?: boolean;
}

export const navigation: Array<{ label: string; items: NavigationItem[] }> = [
  {
    label: 'Visão geral',
    items: [
      {
        label: 'Dashboard',
        href: '/app',
        icon: LayoutDashboard,
        description: 'Indicadores do negócio',
      },
    ],
  },
  {
    label: 'Operação',
    items: [
      { label: 'Estoque', href: '/estoque', icon: Boxes, description: 'Insumos e movimentações' },
      {
        label: 'Pré-preparos',
        href: '/estoque/pre-preparos',
        icon: UtensilsCrossed,
        description: 'Fichas de insumos e produção por lote',
      },
      {
        label: 'Compras',
        href: '/compras',
        icon: ShoppingCart,
        description: 'Entradas e fornecedores',
      },
      {
        label: 'Fornecedores',
        href: '/fornecedores',
        icon: Truck,
        description: 'Cadastro e relacionamento comercial',
      },
      {
        label: 'Motoboys',
        href: '/motoboys',
        icon: Bike,
        description: 'Equipe própria e empresas de entrega',
      },
      {
        label: 'Lista de compras',
        href: '/lista-de-compras',
        icon: ClipboardList,
        description: 'Planejamento de reposição',
      },
      {
        label: 'Histórico',
        href: '/historico-de-compras',
        icon: History,
        description: 'Compras realizadas',
      },
      {
        label: 'Produtos',
        href: '/produtos',
        icon: PackageSearch,
        description: 'Cardápio e precificação',
      },
      {
        label: 'Ficha técnica',
        href: '/ficha-tecnica',
        icon: UtensilsCrossed,
        description: 'Receitas e rendimento',
      },
    ],
  },
  {
    label: 'Gestão',
    items: [
      {
        label: 'Canais e preços',
        href: '/financeiro/canais',
        icon: CreditCard,
        description: 'Preços e comissões por canal',
      },
      {
        label: 'Importar itens de vendas',
        href: '/financeiro/importacao-itens',
        icon: FileUp,
        description: 'Relatórios configuráveis e mapeamento',
      },
      {
        label: 'Ações em lote',
        href: '/operacoes-em-lote',
        icon: ClipboardList,
        description: 'Prévia e cancelamento dos documentos elegíveis',
      },
      {
        label: 'Usuários',
        href: '/usuarios',
        icon: UserRoundCog,
        description: 'Equipe, cargos e permissões',
      },
      {
        label: 'Financeiro',
        href: '/financeiro',
        icon: WalletCards,
        description: 'Receitas e despesas',
      },
      {
        label: 'Portal financeiro',
        href: '/portal-financeiro',
        icon: HandCoins,
        description: 'Assinatura, cobranças e solicitações de upgrade',
        ownerOnly: true,
      },
      {
        label: 'Vendas',
        href: '/financeiro/importacao-vendas',
        icon: FileUp,
        description: 'CSV e planilhas de vendas',
      },
      {
        label: 'Formas de pagamento',
        href: '/financeiro/formas-pagamento',
        icon: CreditCard,
        description: 'Meios de recebimento',
      },
      { label: 'DRE', href: '/dre', icon: FileSpreadsheet, description: 'Resultado gerencial' },
      { label: 'CMV', href: '/cmv', icon: ReceiptText, description: 'Custo por produto' },
      {
        label: 'Análises',
        href: '/analises',
        icon: BarChart3,
        description: 'Tendências e comparativos',
      },
    ],
  },
  {
    label: 'Conformidade',
    items: [
      {
        label: 'Obrigações sanitárias',
        href: '/sanitario',
        icon: ShieldCheck,
        description: 'Fiscalizações e documentos',
      },
    ],
  },
  {
    label: 'Conta e atendimento',
    items: [
      {
        label: 'Segurança e 2FA',
        href: '/seguranca',
        icon: ShieldCheck,
        description: 'Proteção e autenticação em duas etapas',
      },
      {
        label: 'Suporte',
        href: '/suporte',
        icon: LifeBuoy,
        description: 'Chamados e acompanhamento',
      },
    ],
  },
];

export const platformNavigation: Array<{ label: string; items: NavigationItem[] }> = [
  {
    label: 'Plataforma',
    items: [
      {
        label: 'Administração',
        href: '/administracao',
        icon: Settings,
        description: 'Empresas e solicitações comerciais',
      },
      {
        label: 'Afiliados',
        href: '/administracao/afiliados',
        icon: HandCoins,
        description: 'Parceiros, comissões e pagamentos',
      },
    ],
  },
];

export const pageTitles: Record<string, string> = {
  ...Object.fromEntries(
    [...navigation, ...platformNavigation].flatMap((group) =>
      group.items.map((item) => [item.href, item.label]),
    ),
  ),
  '/sanitario/fiscalizacoes': 'Fiscalizações sanitárias',
  '/sanitario/agentes': 'Agentes fiscalizadores',
  '/sanitario/documentos': 'Documentos sanitários',
  '/sanitario/checklists': 'Checklist sanitário',
  '/sanitario/relatorios': 'Relatórios sanitários',
};
